<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import DataTable from "../../components/data-table.svelte";
    import Datepicker from "svelte-calendar";
    import moment from "moment";
    import ModalConfirm from "../components/modalconfirm.svelte";
    import Button from "../components/button.svelte";
    import {validate} from "../../components/validate-action"
    import { createEventDispatcher } from "svelte";
    import Renew from "./renewsubscription.svelte";
    import {AuthUser,getUTCDate} from "../../store";

    let dispatch = new createEventDispatcher();
    let isButtonLoading=false;

    export let ShowSubscription;
    export let ShowPending;
    export let ShowDelete;
    export let ButtonText = "Save Details";
    export let userDetails;
    export let isEdit = false;

    let textright = "";
    let location="";
    if (ShowPending) {
        textright = "text-right";
    }

    let start = new Date();
    let dateFormat = "#{d}/#{m}/#{Y}";
    let noWeekendsSelectableCallback = (date) => date.getDay() !== 0 && date.getDay() !== 6;

    let currrentSubscriptionStart = "", currentSubscriptionRenewal = "", annualFee = "395";
    let dateChosen = false, dateChosen2 = false;
    $: end = new Date(start.getTime() + 1000 * 3600 * 24 * 720);

    let registerOptions = false;
    let registerOptions2 = false;
    let showDeactivationModal = false;
    let showRenewModal = false;
    
    let CustomerNote = "";

    let schoolTypes = [
        { id: 1, text: `School` },
        { id: 2, text: `MAT` },
    ];

    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();

    // if (userDetails == null) 
    // currrentSubscriptionStart = moment(d).format("DD/MM/YYYY");
    //currentSubscriptionRenewal = moment(new Date(year + 1, month, day)).format("DD/MM/YYYY");

    let CalendarStart = new Date(year, month - 6, day);
    let CalendarEnd = new Date(year + 6, month, day);
    let RenewalDate = new Date(year + 1, month, day);

    let SchoolTypeSelected = 1, ServiceSelected = 1;
    let LASelected, EstabSelected, MATSelected = [], MAT = "", MATGroupID = 0;
    let ShowSchools = true, ShowMATs = false, booleanEstab = true;
    let contactname, contactlastname, contactnumber, contactemail;
    let Showcontact = false, samedetails = false;
    let tcontactname = "", tcontactsurname = "", tcontactemail = "", comments;
    let CustomerID = 0;
    let active = false;
    let isEnabled = false;

    let TrustSchools = [];
    let estabs = [];

    onMount(async () => {
        getServices();
        getLAs();
        getTrusts();
        if (userDetails != null) {
            userDetails = userDetails;
            active = userDetails.active;
            annualFee = userDetails.annualFee;
            currentSubscriptionRenewal =  userDetails.currentSubscriptionRenewalstr;
            currrentSubscriptionStart = userDetails.currrentSubscriptionStartstr;
            location = userDetails.location.toString();
            // if (active) {
            //     currentSubscriptionRenewal = userDetails.currentSubscriptionRenewalstr;
            //     currrentSubscriptionStart = userDetails.currrentSubscriptionStartstr;
            // } else {
            //     currentSubscriptionRenewal = userDetails.currentSubscriptionRenewalstr;
            // }
            CustomerID = userDetails.customersID;
            LASelected = userDetails.sGroupID;
            MAT = userDetails.matName;
            MATGroupID = userDetails.matGroupID;

            if (MAT != null && userDetails.schoolID == 0) {
                if (MAT.length > 0 && userDetails.schoolID == 0) {
                    ShowSchools = false;
                    ShowMATs = true;
                    SchoolTypeSelected = 2;
                    MATSelected = userDetails.sGroupID;
                    ShowTrustSchools(MATSelected);
                    registerOptions = true;
                } else {
                    RetrieveEstablisments(LASelected);
                    booleanEstab = false;
                    registerOptions = true;
                    if (!registerOptions) {
                        booleanEstab = true;
                    }
                    EstabSelected = userDetails.schoolID;
                }
            } else {
                RetrieveEstablisments(LASelected);
                booleanEstab = false;
                registerOptions2 = true;
                if (!registerOptions) {
                    booleanEstab = true;
                    registerOptions2 = false;
                }
                EstabSelected = userDetails.schoolID;
            }
            contactname = userDetails.contactName;
            contactlastname = userDetails.contactLastName;
            contactnumber = userDetails.contactNumber;
            contactemail = userDetails.contactEmail;

            if (userDetails.technicalName != null) {
                if (userDetails.technicalName.length > 0) {
                    Showcontact = true;
                    samedetails = true;
                    tcontactname = userDetails.technicalName;
                    tcontactsurname = userDetails.technicalLastName;
                    tcontactemail = userDetails.technicalEmail;
                }
            }

            comments = userDetails.comments;
            isEnabled = userDetails.isEnabled;
        } else {
            registerOptions = true;
            registerOptions2 = true;
        }
    });


    $:{  
        if(userDetails && isEdit)
        {           
            active = userDetails.active;
            annualFee = userDetails.annualFee;
            if (active) {
                currentSubscriptionRenewal =
                    userDetails.currentSubscriptionRenewalstr;
                currrentSubscriptionStart =
                    userDetails.currrentSubscriptionStartstr;
            } else {
                currentSubscriptionRenewal =
                    userDetails.currentSubscriptionRenewalstr;
            }
        }
    }

    let services = [];
    const getServices = async () => {
        let resp = await wrappedFetch("/api/register/GetServices", {
            method: "get",
        });
        services = await resp.json();
        return services;
    };

    const getEstaborMat = async (type) => {
        ShowSchools = false;
        ShowMATs = false;
        MATSelected = "";

        if (type == 1) {
            ShowSchools = true;
        }
        if (type == 2) {
            EstabSelected = "0";
            ShowMATs = true;
            getTrusts();
        }
    };

    const useSameDetails = async (details) => {
        Showcontact = details;
    };

    //export let exportrenewalstatus = [];
    // const handleRenew = async (customer, status) => {
    //     exportrenewalstatus = { status, customer };
    // };

    handleArchivedModal;

    //export let exportdeactivestatus = false;
    // const handleDeactived = async (customer, status) => {
    //     exportdeactivestatus = { status, customer };
    // };

    const handleSetup = async () => {
        handleSubmit(true);
    };
    const handleSaveDetails = async () => {
        handleSubmit(active);
    };

    let showDeleteModal = false;
    const handleArchivedModal = async () => {
        showDeleteModal = true;
    };

    const handleReset = async () => {
        showDeleteModal = false;
    };

    export let exportarchived = false;
    const handleArchived = async () => {
        await wrappedFetch(
            "/api/subscriptions/ArchiveSubscription?CustomerID=" +
                userDetails.customersID,
            { method: "get" }
        );
        exportarchived = true;
    };

    let las = [];
    const getLAs = async () => {
        let resp = await wrappedFetch("/api/uso/GetGroups", { method: "get" });
        las = await resp.json();       
        return las;
    };

    let trusts = [];
    const getTrusts = async () => {
        let resp = await wrappedFetch("/api/uso/GetTrusts", { method: "get" });
        trusts = await resp.json();        
        return trusts;
    };

    async function ShowTrustSchools(sGroupID) {
        TrustSchools = [];
        let resp = await wrappedFetch(
            "/api/USO/GetTrustSchools?sGroupID=" + sGroupID,
            { method: "get" }
        );
        TrustSchools = await resp.json();
    }

    const getTrust = async (sGroupID) => {
        ShowTrustSchools(sGroupID);
    };

    const getEstab = async (LAs) => {
        estabs = await RetrieveEstablisments(LAs);
        //return estabs;
    };

    async function RetrieveEstablisments(sGroupID) {
        booleanEstab = true;
        estabs = [];
        if (sGroupID > 0) {
            let resp = await wrappedFetch(
                "/api/uso/GetEstablishments?sgid=" + sGroupID,
                { method: "get" }
            );
            estabs = await resp.json();
            booleanEstab = false;
            if (!registerOptions) {
                booleanEstab = true;
            }
        }       
        return estabs;
    }

    let errormsg = "";
    let plIntroSignUp = true;

    let chkMAT = [];
    let form;

    const handleSubmit = async (isActivating) => {

        var isValid = jQuery(form).valid();
        errormsg = "";       

        if (isValid) {
            isButtonLoading = true;
            var datecurrrentSubscriptionStart = moment(
                currrentSubscriptionStart,
                "DD/MM/YYYY"
            );
           // var startDate = datecurrrentSubscriptionStart.toDate();
            var currentDate = getUTCDate(datecurrrentSubscriptionStart);//new Date(startDate);
            // currentDate = new Date(
            //     currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
            // ).toJSON();

            var datecurrentSubscriptionRenewal = moment(
                currentSubscriptionRenewal,
                "DD/MM/YYYY"
            );
            //var RenewalData = datecurrentSubscriptionRenewal.toDate();
            var newDate =getUTCDate(datecurrentSubscriptionRenewal);// new Date(RenewalData);
            // newDate = new Date(
            //     RenewalData.getTime() - RenewalData.getTimezoneOffset() * 60000
            // ).toJSON();

            var sGroupID = 0;
            var schoolID = EstabSelected;
            var matName = MAT;

            if (ShowMATs) {
                sGroupID = MATSelected;
                matName = jQuery("#MATSelected option:selected").text();
                schoolID = chkMAT.join(",");
            }

            if (matName.length > 0) {
                sGroupID = MATGroupID
            }

            var data = {
                active: isActivating ? true : active,
                annualFee: annualFee,
                currrentSubscriptionStart: currentDate,
                currentSubscriptionRenewal: newDate,
                contactEmail: contactemail,
                contactName: contactname,
                contactLastName: contactlastname,
                contactNumber: contactnumber,
                customersID: CustomerID,
                matName: matName,
                sGroupID: sGroupID,
                schoolID: schoolID,
                serviceID: ServiceSelected,
                technicalEmail: tcontactemail,
                technicalName: tcontactname,
                technicalLastName: tcontactsurname,
                IsEnabled: isActivating ? true : isEnabled,
                location: $AuthUser!= null? $AuthUser.schoolId == 91669 ? 91669 : parseInt( location):0,
                SignupNote: CustomerNote
            };
            let res = await wrappedFetch(
                `/api/subscriptions/UpdateUserSubscriptions`,
                {
                    method: "post",
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then(r=> r.json())
            .catch(error=> {return { message : "Unexpected error. Please try again."}});
            if (res && res.success) {
                if (isActivating){
                    active = true;
                    isEnabled = true;
                }
                if (CustomerID == 0) {
                    dispatch("added", res.customerId);
                } else {
                    exportarchived = true;
                }
            } else {
                errormsg = res.message; 
                window.scrollTo(0,0);
            }

            isButtonLoading = false;
        }
        else {
            errormsg = "Some fields are invalid";
            window.scrollTo(0,0);
        }
    };

    const onHandleConfirmDeactivate=async()=> {
        isButtonLoading = true;
        let  resp = await wrappedFetch(`/api/subscriptions/DeactiveSubscription?CustomerID=${userDetails.customersID}&schoolId=${userDetails.schoolID}`, {method: "get"});       
        isButtonLoading = false;
        showDeactivationModal = false;
   //     userDetails.active = false;
         userDetails = await wrappedFetch(`/api/subscriptions/GetCustomerDetails?CustomerID=${userDetails.customersID}`).then(response => response.json());
        handleReset();
     //   userDeactived = true;
    }
</script>



{#if errormsg}
    <div class="col-md-12" id="plIntroSignUpConfirm">
        <div class="alert alert-danger">{@html errormsg}</div>
    </div>
{/if}


{#if plIntroSignUp}

    <form bind:this={form} use:validate class="col-md-12" id="plIntroSignUp">
        {#if isEdit}
            <table class="table">
                <thead>
                    <th colspan="4" style="font-size:1rem;">Service Details</th>
                </thead>
                <tbody>
                    <tr>
                        <td style="width:25%"><strong>Service interested in</strong></td>
                        <td style="width:25%">{userDetails.serviceName}</td>              
                        <td colspan="2" style="width:50%">&nbsp;</td>
                    </tr>
                    {#if userDetails.matGroupID > 0}
                        <tr>
                            <td><strong>MAT</strong></td>
                            <td>{userDetails.nameShort}</td>
                            <td><strong>School</strong></td>
                            <td>{userDetails.linkedTrusts}</td>
                        </tr>
                    {:else}
                        <tr>
                            <td><strong>Local Authority</strong></td>
                            <td>{userDetails.nameShort}</td>
                            <td><strong>School</strong></td>
                            <td>{userDetails.estab}</td>
                        </tr>
                    {/if}              
                </tbody>
            </table>
            <br>
            <table class="table">               
                <thead>
                    <th colspan="4" style="font-size:1rem;">Contact Details</th>
                </thead>
                <tbody>
                    <tr>
                        <td style="width:25%;"><strong>Name</strong></td>
                        <td style="width:25%;">{userDetails.contactName} {userDetails.contactLastName}</td>                  
                        <td style="width:25%;"><strong>Telephone</strong></td>
                        <td style="width:25%;">{userDetails.contactNumber}</td>
                    </tr>
                    <tr>
                        <td><strong>Email</strong></td>
                        <td colspan="3">{userDetails.contactEmail}</td>
                    </tr>
                    {#if userDetails.technicalName != null &&  userDetails.technicalName != ""}
                        <tr>
                            <td><strong>Colleague's name</strong></td>
                            <td>{userDetails.technicalName}</td>
                    
                            <td><strong>Colleague's email</strong></td>
                            <td>{userDetails.technicalEmail}</td>
                        </tr>
                    {/if}
                </tbody>
            </table>
            <br>
            <table class="table">               
                <thead>
                    <th colspan="2" style="font-size:1rem;">Subscription Details</th>
                </thead>
                <tbody>
                    <tr>
                        <td style="width:25%;"><strong>Sign up Date</strong></td>
                        <td style="width:25%;">{userDetails.currrentSubscriptionStartstr}</td>
                        <td style="width:25%;"><strong>Renewal Date</strong></td>
                        <td style="width:25%;">{userDetails.currentSubscriptionRenewalstr}</td>
                    </tr>
                    <tr>
                        <td><strong>Annual Fee(£)</strong></td>
                        <td>{userDetails.annualFee}</td>
                        {#if $AuthUser.schoolId == 18854}
                            <td><strong>Location</strong></td>
                            <td>{userDetails.location == 18854?"Orpington":userDetails.location == 91669?"Doncaster":""}</td>
                        {:else}
                            <td colspan="2">&nbsp;</td>
                        {/if}
                    </tr> 
                    <tr>
                        <td colspan="4">
                            <div style="display:flex;">
                            {#if active}
                                <span class="material-icons green" title="Active">done</span>
                                <span class="green"><strong>This subscription is active!</strong></span>
                            {:else}
                                <span class="material-icons red" title="Deactivated">clear</span>
                                <span class="red"><strong>This subscription is inactive since <b>{userDetails.deactivatedOnStr}</b>!</strong></span>
                            {/if}
                            </div> 
                        </td>
                    </tr>            
                </tbody>
            </table>
        {:else}
        <div class="form-group mb-3" style="display:none;">
            <label class="{!registerOptions2 ? 'labeldisabled' : ''}" text="">What service are you interested in?</label><span style="color: rgb(204, 4, 4);"> *</span><br />
            {#each services as service}
                <div class="form-check form-check-inline">
                    <label class="form-check-label">
                        <input
                            type="radio"
                            id={service}
                            bind:group={ServiceSelected}
                            value={service.servicesID}
                            class="form-check-input"
                            disabled={!registerOptions2}
                        />
                        {service.serviceName}</label
                    >
                </div>
            {/each}
        </div>

        <div class="form-group mb-3">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <label class="{!registerOptions ? 'labeldisabled' : ''}"
                        >Are you interested in subscribing for your school or
                        MAT?
                    </label><span style="color: rgb(204, 4, 4);"> *</span><br />
                    {#each schoolTypes as type}
                        <div class="form-check  form-check-inline">
                            <label class="form-check-label">
                                <input
                                    type="radio"
                                    id={type}
                                    bind:group={SchoolTypeSelected}
                                    value={type.id}
                                    on:change={() =>
                                        getEstaborMat(SchoolTypeSelected)}
                                    class="form-check-input"
                                    disabled={!registerOptions}
                                />
                                {type.text}</label
                            >
                        </div>
                    {/each}
                </div>

                {#if ShowSchools}
                    <div class="col-md-4 mb-2">
                        <select
                            bind:value={LASelected}
                            on:change={() => getEstab(LASelected)}
                            class="form-control"
                            disabled={!registerOptions}
                            name="la"
                            required
                        >
                        <option value="">
                            Select your Local Authority
                        </option>
                            {#each las as la}
                                <option value={la.sGroupID}>
                                    {la.nameShort}
                                </option>
                            {/each}
                        </select>
                    </div>
                    <div class="col-md-4">
                        <select
                            bind:value={EstabSelected}
                            class="form-control"
                            disabled={booleanEstab}
                            name="school"
                            required
                        >
                        <option value="">
                            Select your School
                        </option>
                            {#each estabs as estab}
                                <option value={estab.schoolID}>
                                    {#if estab.leaid.length > 0}
                                        {estab.estab} ({estab.leaid}-{estab.dfESID})
                                    {:else}
                                        {estab.estab}
                                    {/if}
                                </option>
                            {/each}
                        </select>
                    </div>
                {/if}

                {#if ShowMATs}
                    <div class="col-md-8">
                        <select
                            id="MATSelected"
                            bind:value={MATSelected}
                            on:change={() => getTrust(MATSelected)}
                            class="form-control"
                            disabled={!registerOptions}
                            required
                        >
                        <option value="">
                            Select your MAT
                        </option>
                            {#each trusts as trust}
                                <option value={trust.sGroupID}>
                                    {trust.nameShort}
                                </option>
                            {/each}
                        </select>
                    </div>
                    {#if MATSelected && ShowPending}
                        <div class="col-md-12 mt-3">
                            Establishments in this MAT
                            <div class="table-responsive">
                                <DataTable
                                    buttons=""
                                    info={false}
                                    searching={false}
                                    DataLength={TrustSchools.length}
                                    message="There are currently establishments in this MAT" ResponsiveHeader='1'
                                >
                                    <thead>
                                        <tr>
                                            <th>DfE</th>
                                            <th>School</th>
                                            <th>Address</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each TrustSchools as school}
                                            <tr>
                                                <td
                                                    >{school.leaid}-{school.dfESID}</td
                                                >
                                                <td>{school.estab}</td>
                                                <td
                                                    >{school.address1}, {#if school.address2}{school.address2},{/if}
                                                    {school.city}, {school.county},
                                                    {school.postcode}</td
                                                >
                                                <td>
                                                    {#if school.customers}
                                                        <a
                                                            href="#"
                                                            on:click|preventDefault={() =>
                                                                ViewSchool(
                                                                    school
                                                                        .customers
                                                                        .customersID
                                                                )}
                                                            ><span
                                                                class="material-icons"
                                                                >visibility</span
                                                            ></a
                                                        >
                                                    {:else}
                                                        <input
                                                            type="checkbox"
                                                            bind:group={chkMAT}
                                                            value={school.schoolID}
                                                        />
                                                    {/if}
                                                </td>
                                            </tr>
                                        {/each}
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                    {/if}
                {/if}
            </div>
        </div>

        <div class="form-group mb-3">
            <div class="row">
                <div class="col-md-3 mb-2">
                    <label for="firstname">First name</label>{#if location==18854}<span style="color: rgb(204, 4, 4);"> *</span>{/if}<br />
                    <input
                        type="text"
                        class="form-control"
                        bind:value={contactname}
                        name="firstname"
                        required={location==18854}
                    />
                </div>
                <div class="col-md-3 mb-2">
                    <label for="surname">Last name</label>{#if location==18854}<span style="color: rgb(204, 4, 4);"> *</span>{/if}<br />
                    <input
                        type="text"
                        class="form-control"
                        bind:value={contactlastname}
                        name="surname"
                        id="surname"
                        required={location==18854}
                    />
                </div>
                <div class="col-md-3 mb-2">
                    <label for="telephone">Telephone number</label>{#if location==18854}<span style="color: rgb(204, 4, 4);"> *</span>{/if}<br />
                    <input
                        type="phone"
                        class="form-control"
                        bind:value={contactnumber}
                        name="telephone"
                        id="telephone"
                        required={location==18854}
                    />
                </div>
                <div class="col-md-3">
                    <label for="email">Email address</label>{#if location==18854}<span style="color: rgb(204, 4, 4);"> *</span>{/if}<br />
                    <input
                        type="email"
                        class="form-control"
                        bind:value={contactemail}
                        name="email"
                        id="email"
                        required={location==18854}
                    />
                </div>
            </div>
        </div>

        {#if !ShowPending}
        <div class="form-group mb-3">
            <div class="row">
                <div class="col-md-12">
                    <label>Message</label>
                    <textarea class="form-control" rows="5" bind:value={CustomerNote} placeholder="Please include any questions you have or relevant information."></textarea>
                </div>
            </div>
        </div>
        {/if}
        <div class="form-group d-none">
            <div class="row">
                <div class="col-md-8 mb-2">
                    <input
                        type="checkbox"
                        bind:checked={samedetails}
                        on:change={() => useSameDetails(samedetails)}
                    />
                    <label
                        >Add the contact details of a colleague (preferably with
                        an IT remit)</label
                    >
                </div>
            </div>
        </div>
        {#if Showcontact}
            <div class="form-group mb-3 d-none">
                <div class="row">
                    <div class="col-md-4 mb-2">
                        <label>Colleague's first name</label><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={tcontactname}
                            name="colleagueName"
                            id="colleagueName"
                            
                        />
                    </div>
                    <div class="col-md-4 mb-2">
                        <label>Colleague's last name</label><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={tcontactsurname}
                            name="colleagueName"
                            id="colleagueName"
                            
                        />
                    </div>
                    <div class="col-md-4">
                        <label>Colleague's email address</label><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={tcontactemail}
                            name="colleagueEmail"
                            id="colleagueEmail"
                            
                        />
                    </div>
                </div>
            </div>
        {/if}

        {#if ShowSubscription || ShowPending}
            <h4>Subscription Details</h4>

            <div class="form-group mb-3">
                <div class="row">
                    {#if !ShowPending}
                        <div class="col-md-3 mb-2">
                            <div class="d-none d-md-block">
                                <label>&nbsp;</label><br />
                            </div>
                            {#if active}
                                <span
                                    class="material-icons green"
                                    title="Active">done</span
                                ><span class="green"
                                    ><strong
                                        >This subscription is active!</strong
                                    ></span
                                >
                            {:else}
                                <span
                                    class="material-icons red"
                                    title="Deactivated">clear</span
                                ><span class="red"
                                    ><strong
                        >This subscription is inactive since <b>{userDetails.deactivatedOnStr}</b>!</strong
                                    ></span
                                >
                            {/if}
                        </div>
                    {/if}
                    <div class="col-md-3 mb-2">
                        <label for="currrentSubscriptionStart">Sign up date</label><span style="color: rgb(204, 4, 4);"> *</span><br />
                        <!-- <input
                            type="text"
                            class="form-control"
                            bind:value={currrentSubscriptionStart}
                        /> -->
                        <Datepicker bind:formattedSelected={currrentSubscriptionStart} bind:dateChosen style="width:100%;text-align:left" format={dateFormat}>
                            <input type="text" class="form-control" bind:value={currrentSubscriptionStart} name="currrentSubscriptionStart" id="currrentSubscriptionStart" required>                        
                        </Datepicker>
                    </div>
                    <div class="col-md-3 mb-2">
                        <label class="{!ShowPending ? 'labeldisabled' : ''}">Renewal Date</label><span style="color: rgb(204, 4, 4);"> *</span><br />
                        {#if !ShowPending}
                            <input
                                type="text"
                                class="form-control"
                                bind:value={currentSubscriptionRenewal}
                                disabled={!ShowPending}                            
                            />
                        {:else}
                            <Datepicker
                                bind:formattedSelected={currentSubscriptionRenewal}
                                bind:dateChosen2
                                style="width:100%;text-align:left"
                                format={dateFormat}
                                start={CalendarStart}
                                end={CalendarEnd}
                                selected={RenewalDate}
                            >
                                <input
                                    type="text"
                                    class="form-control"
                                    bind:value={currentSubscriptionRenewal}
                                    name="currentSubscriptionRenewal"
                                    id="currentSubscriptionRenewal"
                                    required
                                />
                            </Datepicker>
                        {/if}
                    </div>
                    <div class="col-md-3">
                        <label class="{!ShowPending ? 'labeldisabled' : ''}">Annual Fee £</label><span style="color: rgb(204, 4, 4);"> *</span><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={annualFee}
                            disabled={!ShowPending}
                            name="annualFee"
                            id="annualFee"
                            required
                        />
                    </div>
                    {#if $AuthUser.schoolId == 18854}
                    <div class="col-md-3">
                        <label>Orpington or Doncaster</label><span style="color: rgb(204, 4, 4);"> *</span><br />
                        <select
                        bind:value={location}                       
                        class="form-control"                      
                        name="location"
                        required>
                    <option value>Select location</option>
                    <option value=18854>Orpington</option>
                    <option value=91669>Doncaster</option>
                    </select>
                    </div>
                    {/if}
                </div>
            </div>

            <!-- {#if EstabSelected}
                <Permissions
                    schoolId={EstabSelected}
                    embedded={true}             
                />
            {/if} -->
        {/if}
        {/if}
        <div class="form-group mb-3 d-none">
            <label>Message<br /></label>
            <textarea class="form-control" bind:value={comments} />
        </div>
    
        <div class="form-group text-right mt-3 mb-3">
            {#if ShowSubscription}            
                <button
                    class="btn btn-primary ml-2"
                    type="button"
                    on:click|preventDefault={() =>
                    {
                        showRenewModal = true;
                       // handleRenew(userDetails, true)
                    }
                    }
                    >Renew Subscription</button
                >
                {#if active}
                    <button
                        class="btn btn-danger ml-2"
                        type="button"
                        on:click|preventDefault={() =>
                       { 
                           showDeactivationModal = true;
                            //handleDeactived(userDetails, true)
                       }
                            }
                        >Deactivate Subscription</button
                    >
                {/if}
            {/if}
            {#if ShowPending}
                        <Button buttonClass={"btn-primary ml-2"} buttonText={"Activate Subscription"} bind:isLoading={isButtonLoading}  on:click={() => handleSetup(userDetails)}/>
                <!-- <button
                    class="btn btn-primary ml-2"
                    type="button"
                    on:click|preventDefault={() => handleSetup(userDetails)}
                    >Activate Subscription</button
                > -->
                {#if ShowDelete}
                    <button
                        class="btn btn-danger ml-2"
                        type="button"
                        on:click|preventDefault={handleArchivedModal}
                        >Delete</button
                    >
                {/if}
            {:else if !isEdit}
            <Button buttonClass={"btn-primary ml-2"} buttonText={ButtonText} bind:isLoading={isButtonLoading}  on:click={handleSaveDetails} />
                <!-- <button
                    class="btn btn-primary ml-2"
                    type="button"
                    on:click|preventDefault={handleSaveDetails}>{ButtonText}</button
                > -->
            {/if}
        </div>
    </form>
{/if}

<ModalConfirm
    showModal={showDeleteModal}
    on:close={handleReset}
    bind:isButtonLoading={isButtonLoading}
    zindex="1052"
    sizeClass="modal-md"
    targetClass="confirm-options"
    on:confirm={handleArchived}
>
    <div slot="header">
        <h4 class="title">Delete Subscription</h4>
    </div>
    <div slot="content">Are you sure you want to delete this subscription?</div>
</ModalConfirm>
{#if showRenewModal}
<Renew bind:showRenewModal {userDetails} on:close={handleReset} sizeClass="modal-md" on:renew={async()=> userDetails = await wrappedFetch('/api/subscriptions/GetCustomerDetails?CustomerID=' + CustomerID).then(response => response.json())} />
{/if}

<ModalConfirm showModal={showDeactivationModal} on:close={handleReset} bind:isButtonLoading={isButtonLoading} zindex="1052" sizeClass="modal-md" targetClass="confirm-options" on:confirm={()=>onHandleConfirmDeactivate()} >
    <div slot="header">  
        <h4 class="title">Deactivate subscription</h4>
    </div>
    <div slot="content">
        Are you sure you would like to deactivate this establishment?
    </div>
</ModalConfirm>
<style>
</style>
